/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({
    NeedHelp: {
        id: 'qnb.spt.insurancePage.SgSptPhoneModal.NeedHelp',
        defaultMessage: 'We\'re here to help'
    },
    PleaseCall: {
        id: 'qnb.spt.insurancePage.SgSptPhoneModal.PleaseCall',
        defaultMessage: 'Call us on'
    },
    CloseButton: {
        id: 'qnb.spt.insurancePage.SgSptPhoneModal.CloseButton',
        defaultMessage: 'Close'
    },
    TimeWeekDays: {
        id: 'qnb.spt.insurancePage.SgSptPhoneModal.TimeWeekDays',
        defaultMessage: 'Weekdays: 8:30am to 7pm'
    },
    TimeSaturday: {
        id: 'qnb.spt.insurancePage.SgSptPhoneModal.TimeSaturday',
        defaultMessage: 'Saturdays: 8:30am to 5pm'
    },
    TimeSunday: {
        id: 'qnb.spt.insurancePage.SgSptPhoneModal.TimeSunday',
        defaultMessage: 'Sundays: '
    },
    Or: {
        id: 'qnb.spt.insurancePage.SgSptPhoneModal.Or',
        defaultMessage: 'Or...'
    },
    LeaveMessage: {
        id: 'qnb.spt.insurancePage.SgSptPhoneModal.LeaveMessage',
        defaultMessage: 'Leave a message'
    },
    ChatOnlineButton: {
        id: 'qnb.spt.insurancePage.SgSptPhoneModal.ChatOnlineButton',
        defaultMessage: 'Chat online'
    },
    ChatOnlineMsgOne: {
        id: 'qnb.spt.insurancePage.SgSptPhoneModal.ChatOnlineMsgOne',
        defaultMessage: '<b>Live chat</b>: Chat with one of our travel insurance experts online now '
    },
    ChatOnlineMsgTwo: {
        id: 'qnb.spt.insurancePage.SgSptPhoneModal.ChatOnlineMsgTwo',
        defaultMessage: 'It\'s fast, free and there\'s no pressure. Chat in your own pace and time.'
    },
    CallUsMsgOne: {
        id: 'qnb.spt.insurancePage.SgSptPhoneModal.CallUsMsgOne',
        defaultMessage: '<b>Call us free</b>: Talk to one of our friendly agents over the phone '
    },
    CallUsMsgTwo: {
        id: 'qnb.spt.insurancePage.SgSptPhoneModal.CallUsMsgTwo',
        defaultMessage: 'Give us a call, we\'d love to hear from you.'
    },
    LinesAreCurrently: {
        id: 'qnb.spt.insurancePage.SgSptPhoneModal.LinesAreCurrently',
        defaultMessage: 'Lines are currently'
    },
    Open: {
        id: 'qnb.spt.insurancePage.SgSptPhoneModal.Open',
        defaultMessage: 'Open'
    },
    Closed: {
        id: 'qnb.spt.insurancePage.SgSptPhoneModal.Closed',
        defaultMessage: 'Closed'
    },
});
